module.exports = __webpack_public_path__ + "static/media/IMG-2836.06ba49de.jpg";